export const addResultReducer = (prev, update) => {
    return { ...prev, requestStatusMap: { ...prev.requestStatusMap, [update.result.GeoObject.sk]: update.result } };
};
